<template>
    <div class="table_wrap">
        <div class="c_table_wrap table_search_wrap">
            <div class="filter-select-div el-filter-date mb11">
                <span class="filter-select-span mr24">일시</span>
                <span class="el-date-icon mr2" :class="checkFilterData() ? 'iconMove' : ''">
                        <span class="el-date-icon-img"></span>
                        <el-date-picker
                            v-model="filterDate"
                            type="daterange"
                            range-separator=""
                            value-format="yyyy-MM-dd"
                            start-placeholder="시작날짜"
                            end-placeholder="끝 날짜"
                            @change="setFilterDate('filterDate', 'cr', filterDate)"
                            class="el-date-common"
                            prefix-icon=" "
                            clear-icon="el-icon-circle-close el-clear-icon"
                        ></el-date-picker>
                    </span>
            </div>
            <br/>
            <div class="filter-select-div el-filter-date ">
                <span class="filter-select-span mr24">검색</span>
                <el-select v-model="searchInputOption" class="select mr5">
                    <el-option :value="'ni'" :label="'닉네임'"></el-option>
                    <el-option :value="'mid'" :label="'아이디'"></el-option>
                </el-select>
                <el-input
                    class="table_s_input search-input mr5"
                    v-model="searchInput"
                    size=""
                    placeholder="검색어를 입력해주세요."
                    maxLength="40"
                    @keyup.enter.native="setFilterFunc(searchInputOption, searchInput)"
                >
                </el-input>
                <el-button class="search-button" @click="setFilterFunc(searchInputOption, searchInput)">
                    검색
                </el-button>
            </div>

            <div class="filter-show-count">
                <el-select v-model="size" @change="changePage('size', size)">
                    <el-option v-for="(sizeData) in sizeList" :key="`size${sizeData}`" :value="sizeData"
                               :label="`${sizeData}개씩 보기`"></el-option>
                </el-select>
            </div>
        </div>
    </div>
</template>

<script>
import paymentUtil from "@/components/payment/paymentUtil";
import EventBus from "@/utils/event-bus";
import util from "@/mixins/util";

const {filterConfig} = paymentUtil;
export default {
    name: "PaymentFilterDefaultLayout",
    mixins: [],
    components: {},
    inject: ['paymentSetPage', 'setFilter'],
    provide() {
        return {}
    },
    props: {
        filterData: {
            default: () => {
                return {}
            }
        },
        paginationData: {
            default: () => {
                return {total: 0, page: 0, size: 0,}
            }
        },

    },
    data() {
        return {
            searchInput: '',
            searchInputOption:'ni',
            filterUse: '',
            filterDate: [],
            filterArea: '',

            filterSort: '',
            size: 10,
            sizeList: [10, 30, 50],

            selectSort: false,
        }
    },
    created() {
    },
    mounted() {
        this.setterFilterDataInData();

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        setterFilterDataInData() {
            let classnames = Object.keys(this.filterData);
            classnames.forEach(classname => {
                let obj = this.filterData[classname];
                let type = filterConfig[obj.key].type;
                if (this.hasOwnProperty(classname)) {
                    if (type == 'query') {
                        this[classname] = obj.query;
                        if (this.hasOwnProperty(classname + 'Option')) {
                            this[classname + 'Option'] = obj.key;
                        }
                    } else if (type === 'between') {
                        // this[classname] = [obj.start, obj.end];
                        let start = this.$moment(obj.start * 1000).format("yyyy-MM-DD")
                        let end = this.$moment(obj.end * 1000).format("yyyy-MM-DD")
                        this[classname] = [start, end];

                    } else if (type === 'match') {
                        if (isNaN(obj.value)) {
                            this[classname] = obj.value;
                        } else {
                            this[classname] = Number(obj.value);
                        }

                    }

                }
            })
            this.size = this.paginationData.size;
        },
        setFilterFunc(key, value) {
            this.setFilter(key, value);
        },

        changePage(key, value) {
            this.paymentSetPage(key, value);
            this.paymentSetPage('page', 1);
        },
        checkFilterData() {
            return this.filterDate != null && this.filterDate.length > 0;
        },
        changeSort(sort) {

            sort ? this.filterSort = 'desc' : this.filterSort = 'asc'
            this.setFilter('obs', this.filterSort)
        },
        setFilterDate(classname, key, value) {
            let date = []
            if (!util.isEmpty(value)) {
                /* this[classname][0] = `${value[0]} 00:00:00`
                 this[classname][1] = `${value[1]} 23:59:59`*/
                // date[0] = this.$moment(`${value[0]} 00:00:00`).format('X')
                // date[1] = this.$moment(`${value[1]} 23:59:59`).format('X')
                // console.log("data",date)
                this.setFilterFunc('cr', value);
            } else this.setFilterFunc('cr', this[classname]);
        },

    },
    watch: {},
}
</script>

<style lang="scss">

</style>